export const WEB_DISCOUNTS = [
  { id: "m", months: 1, discount: 0.0, label: "Monthly", sublabel: "No discount" },
  { id: "q", months: 3, discount: 0.05, label: "3 months", sublabel: "Save 5%" },
  { id: "h", months: 6, discount: 0.10, label: "6 months", sublabel: "Most popular • Save 10%" },
  { id: "y", months: 12, discount: 0.20, label: "12 months", sublabel: "Best value • Save 20%" },
];

export const WEB_PLANS = [
  {
    id: "starter",
    name: "Starter",
    badge: "Best for landing pages",
    monthly: 3,
    specs: {
      sites: "1 site",
      storage: "10GB NVMe",
      bandwidth: "Unmetered*",
      email: "Optional add-on",
      ssl: "Free SSL",
      backups: "Daily",
    },
    idealFor: ["Personal sites", "Small landing pages", "Simple portfolios"],
  },
  {
    id: "plus",
    name: "Plus",
    badge: "Most popular",
    monthly: 7,
    specs: {
      sites: "5 sites",
      storage: "30GB NVMe",
      bandwidth: "Unmetered*",
      email: "Optional add-on",
      ssl: "Free SSL",
      backups: "Daily",
    },
    idealFor: ["Small businesses", "Blogs", "Multiple projects"],
  },
  {
    id: "business",
    name: "Business",
    badge: "Best for stores",
    monthly: 10,
    specs: {
      sites: "10 sites",
      storage: "75GB NVMe",
      bandwidth: "Unmetered*",
      email: "Included (10 GB)",
      ssl: "Free SSL",
      backups: "Daily",
    },
    idealFor: ["eCommerce sites", "Agencies", "Higher traffic sites"],
  },
];
